const translate = {
  navbar: {
    btn0: ["Start Experimenting", "ابدأ تجربتك"],
    ourServices: ["Services", "خدماتنا"],
    ourPartners: ["Partners", "شركاؤنا"],
    packagesAndSubscriptions: [
      "Packages & Subscriptions",
      "الباقات و الاشتراكات",
    ],
    help: ["Help", "المساعدة"],
    privacyPolicy: ["Privacy Policy", "سياسة الخصوصية"],
    trems: ["Terms & Conditions", "الشروط و الأحكام"],
  }, ////navbar
  home: {
    documentTitle: [
      "MyCash - the perfect solution for sales management",
      "ماى كاش - الحل الامثل لادارة المبيعات",
    ],
    btn0: ["Start Now", "ابدأ الان"],
    packages: {
      title: [
        "Choose the plan you want with myCASH",
        "اختر الخطة التي تريدها مع myCASH",
      ],
      subTitle: [
        "Don't miss the opportunity to take advantage of our special offers and get exclusive benefits.",
        "لا تضيع الفرصة للاستفادة من عروضنا المميزة والحصول على مزايا حصرية .",
      ],
    },
    homeFooter: {
      moreAboutUs: ["More About Us", "المزيد عننا"],
      address: [
        "3273, Anas bin Malik, Al-Sahafa District, 8369",
        "3273، أنس بن مالك، حى الصحافة، 8369",
      ],
      taxNumber: [
        "Tax number: 302267551800003",
        "الرقم الضريبي: 302267551800003",
      ],
      paymentMethod: ["Our Payment Methods", "طرق الدفع لدينا"],
    },
  }, //home
  contactUs: {
    documentTitle: ["MyCash - Contact Us", "ماى كاش - تواصل معنا"],
    title: ["How can we help you?", "كيف يمكننا تقديم لك المساعدة؟"],
    det: [
      "Leave your question or inquiry here and one of our representatives will contact you as soon as possible.",
      "اترك سؤالك أو استفسارك هنا و سيقوم أحد ممثلينا بالتواصل معك فى أقرب وقت.",
    ],
    name: ["Full Name", "الاسم بالكامل"],
    namePlaceholder: ["Enter your name here", "أدخل اسمك هنا"],
    email: ["Email", "بريدك الإلكتروني"],
    emailPlaceholder: [
      "Enter your email address",
      "أدخل عنوان بريدك الإلكتروني",
    ],
    phone: ["Phone Number", "رقم هاتفك"],
    phonePlaceholder: ["Enter your phone number here", "أدخل رقم هاتفك هنا"],
    message: ["Message", "نص رسالتك"],
    messagePlaceholder: ["Your message", "نص الرسالة..."],
    btn: ["Send", "إرسال"],
  }, //Contact Us
  footer: {
    title: [
      "All copyrights reserved. ©2022 MyCash Company",
      "جميع الحقوق محفوظة. ©2022 شركة ماي كاش ",
    ],
  }, //Footer
  privacyPolicy: {
    documentTitle: ["MyCash - Privacy Policy", "ماى كاش - سياسة الخصوصية"],
    title: ["Privacy Policy", "سياسة الخصوصية"],
  }, ///PrivacyPolicy
  trems: {
    documentTitle: [
      "MyCash - Terms & Conditions",
      "ماى كاش - الشروط و الأحكام",
    ],
    title: ["Terms & Conditions", "الشروط و الأحكام"],
  }, ///trems
  returnPolicy: {
    documentTitle: ["MyCash - Return Policy", "ماى كاش - سياسة الاسترجاع"],
    title: ["Return Policy", "سياسة الاسترجاع"],
  }, ///returnPolicy

  start: {
    documentTitle: ["MyCash - Start Your Experience", "ماى كاش - ابدأ تجربتك"],
    det0: ["Run your stores in the best way", "أدر متاجرك بأفضل طريقة "],

    btn: ["Start Now", "ابدأ الان"],
  },
  pageNotFound: {
    title: ["Page Not Found", "الصفحة غير موجودة"],
    dec: [
      "We couldn't find what you were looking for",
      "لم نتمكن من العثور على ما كنت تبحث عنه",
    ],
  }, //pageNotFound
};
export default translate;
